import { formatDate } from './dateTimeFormat';

export const dateFormat = (dateString) => formatDate(dateString);
